export default __webpack_public_path__ + "static/cost-380091cdc48e32866218ec0cf1bee1ca.svg";